module.exports = __webpack_public_path__ + "img/particle_motion_00096.9597c817.png";